// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"7fdc82b3","94":"5e583981","148":"d52d382a","197":"54e2f273","239":"4e753b0d","332":"46ddbedb","384":"9a0985ad","433":"7fda14a4","573":"fdab4409","583":"85585960","830":"59f75498"}[chunkId] + ".chunk.js";
};